import React from "react";
import { ArrowRight, Bookmark, ClipboardList, Flag, Play } from "lucide-react";
import TeamLogo from "@/components/TeamLogo";

function MenuRow({ icon: Icon, title, description, onClick, variant = "secondary" }) {
  return (
    <button
      type="button"
      className="native-v3-protocol-menu-row"
      data-variant={variant}
      onClick={onClick}
    >
      <span className="native-v3-protocol-menu-icon" aria-hidden="true">
        <Icon />
      </span>
      <span className="native-v3-protocol-menu-copy">
        <strong>{title}</strong>
        {description ? <span>{description}</span> : null}
      </span>
      <ArrowRight className="native-v3-protocol-menu-arrow" aria-hidden="true" />
    </button>
  );
}

export default function NativeProtocolStartMenu({
  activeMatch,
  onStart,
  onResume,
  onCreated,
  onSaved,
  createdCount = 0,
  savedCount = 0,
}) {
  const hasActiveMatch = Boolean(activeMatch?.id);
  const hasCreated = createdCount > 0;
  const hasSaved = savedCount > 0;
  const hasLibraryActions = hasCreated || hasSaved;
  const countLabel = (count) => `${count} protokoll`;

  return (
    <div
      className="native-v3-protocol-start-menu"
      data-has-active-protocol={hasActiveMatch ? "true" : "false"}
    >
      {hasActiveMatch ? (
        <button type="button" className="native-v3-protocol-active" onClick={onResume}>
          <span className="native-v3-protocol-active-label">Pågående protokoll</span>
          <span className="native-v3-protocol-active-match">
            <span>
              <TeamLogo teamName={activeMatch.home_team} size={34} />
              <strong>{activeMatch.home_team || "Hemmalag"}</strong>
            </span>
            <small>mot</small>
            <span>
              <TeamLogo teamName={activeMatch.away_team} size={34} />
              <strong>{activeMatch.away_team || "Bortalag"}</strong>
            </span>
          </span>
          <span className="native-v3-protocol-active-action">
            <Play aria-hidden="true" /> Fortsätt protokoll
          </span>
        </button>
      ) : null}

      <div className="native-v3-protocol-menu-list">
        <MenuRow
          icon={Flag}
          title="Starta matchprotokoll"
          description="Välj en officiell match och börja registrera heat."
          onClick={onStart}
          variant="primary"
        />
        {hasLibraryActions ? (
          <div
            className="native-v3-protocol-library-actions"
            data-single={hasCreated !== hasSaved ? "true" : "false"}
          >
            {hasCreated ? (
              <MenuRow
                icon={ClipboardList}
                title="Skapade"
                description={countLabel(createdCount)}
                onClick={onCreated}
                variant="library"
              />
            ) : null}
            {hasSaved ? (
              <MenuRow
                icon={Bookmark}
                title="Sparade"
                description={countLabel(savedCount)}
                onClick={onSaved}
                variant="library"
              />
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
